import * as actionTypes from "../constants";
import { USER_FEATURES } from "../models";
import { getUserFeatures } from "../services/users";

import type { ThunkAction } from "redux-thunk";
import type { UserFeature, UserFeaturesAvailablePackages } from "../models";
import type { State } from "../reducers";

interface GetAvailableFeaturesAction {
  type: typeof actionTypes.USER_FEATURES_BEGIN;
  payload: string;
}

interface GetAvailableFeaturesCompletedAction {
  type: typeof actionTypes.USER_FEATURES_COMPLETED;
  payload: UserFeaturesAvailablePackages;
}

interface GetAvailableFeaturesErrorAction {
  type: typeof actionTypes.USER_FEATURES_ERROR;
  payload: Error;
}

type UserFeaturesAction =
  | GetAvailableFeaturesAction
  | GetAvailableFeaturesCompletedAction
  | GetAvailableFeaturesErrorAction;

const mapFeatures = (packages: UserFeature[]) =>
  Object.values(USER_FEATURES).reduce<UserFeaturesAvailablePackages>(
    (accumulator, currentValue) => ({
      ...accumulator,
      [currentValue]: packages.includes(currentValue),
    }),
    {
      ProFee: false,
      FutureDates: false,
      FAC: false,
      PSA: false,
      STU: false,
    },
  );

export const getAvailableFeaturesAction =
  (): ThunkAction<void, State, unknown, UserFeaturesAction> => async (dispatch) => {
    try {
      dispatch(getAvailableFeaturesActionBegin());

      const features = await getUserFeatures();

      dispatch(getAvailableFeaturesActionCompleted(mapFeatures(features)));
    } catch (error) {
      dispatch(getAvailableFeaturesActionError(error as Error));
    }
  };

const getAvailableFeaturesActionBegin = (): GetAvailableFeaturesAction => ({
  payload: "",
  type: actionTypes.USER_FEATURES_BEGIN,
});

const getAvailableFeaturesActionCompleted = (
  list: UserFeaturesAvailablePackages,
): GetAvailableFeaturesCompletedAction => ({
  payload: list,
  type: actionTypes.USER_FEATURES_COMPLETED,
});

const getAvailableFeaturesActionError = (error: Error): GetAvailableFeaturesErrorAction => ({
  payload: error,
  type: actionTypes.USER_FEATURES_ERROR,
});
